import * as React from 'react';
import { Button, RouterLink } from '../../../../core';

export type AppBarNavigationItem = {
  label: string;
  href?: string;
  onClick?: () => void;
};

export type AppBarNavigationProps = {
  items?: AppBarNavigationItem[];
  color?: 'info' | 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  /**
   * Optional Link component for navigation.
   * Use NextLink for Next.js apps or LinkRouter for React Router SPAs.
   * Defaults to RouterLink if not provided.
   */
  LinkComponent?: React.ElementType;
};

const defaultItems: AppBarNavigationItem[] = [
  { label: 'Features' },
  { label: 'Testimonials' },
  { label: 'Highlights' },
  { label: 'Pricing' },
  { label: 'FAQ' },
  { label: 'Blog' },
];

export function AppBarNavigation({
  items = defaultItems,
  color = 'info',
  size = 'small',
  LinkComponent = RouterLink,
}: AppBarNavigationProps) {
  return (
    <>
      {items.map((item, index) => {
        const isInternal = !!item.href && item.href.startsWith('/');
        const baseSx =
          item.label === 'FAQ' || item.label === 'Blog' ? { minWidth: 0 } : {};
        const linkTargetProps = { href: item.href, to: item.href };
        return isInternal ? (
          <Button
            key={index}
            variant="text"
            color={color}
            size={size}
            component={LinkComponent}
            {...linkTargetProps}
            onClick={item.onClick}
            sx={baseSx}
          >
            {item.label}
          </Button>
        ) : (
          <Button
            key={index}
            variant="text"
            color={color}
            size={size}
            href={item.href}
            onClick={item.onClick}
            sx={baseSx}
          >
            {item.label}
          </Button>
        );
      })}
    </>
  );
}
